import { TabsEnum } from './enums'

export const pageShouldShowHeroSignUpButton = (page: TabsEnum): boolean => {
  if (!page) {
    return false
  }
  return [TabsEnum.INFO, TabsEnum.GAME, TabsEnum.PLAYERS, TabsEnum.STARLIST].includes(page)
}
